import React from 'react';
import { at } from 'lodash';
import { useField, useFormikContext } from 'formik';
import { Checkbox, FormControl, FormControlLabel, FormHelperText } from '@mui/material';

export default function CheckboxField(props: any) {
  const { label, ...rest } = props;
  const [field, meta, helper] = useField(props);

  const formikProps: any = useFormikContext();
  const [touched, error] = at(meta, 'touched', 'error');
  const isError = touched && error;

  function _renderHelperText() {
    if (isError) {
      return <FormHelperText error>{error}</FormHelperText>;
    }
  }

  function _onChange(e: any) {
    formikProps.setFieldValue(field.name, e.target.checked);
    if (props.onChange) props.onChange(e);
  }

  return (
    <FormControl {...rest} error={!!isError}>
      <FormControlLabel
        control={<Checkbox {...field} checked={!!field.value} onChange={_onChange} />}
        label={label}
      />
      {_renderHelperText()}
    </FormControl>
  );
}
